import { graphql } from "../gql";

export const getHeadToHeadTopLevelDataQuery = graphql(`
  query GetHeadToHeadTopLevelData($input: OddsMarketTypesInput!) {
    event(input: $input) {
      eventUrl
      playerPropOdds {
        totalPassingYards {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          result {
            type
          }
          teamNumberFireId
          player {
            numberfireId
            name
            lastName
            jerseyNumber
            imageUrl
            position
            injury {
              injured
              description
              publishedAt
              status
            }
            teamInfo {
              logo {
                svg
              }
              name
              shortName
              teamJersey {
                svg
              }
            }
          }
          playerStat {
            value
            units
            period
          }
        }
        totalRushingYards {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          result {
            type
          }
          teamNumberFireId
          player {
            numberfireId
            name
            lastName
            jerseyNumber
            imageUrl
            position
            injury {
              injured
              description
              publishedAt
              status
            }
            teamInfo {
              logo {
                svg
              }
              name
              shortName
              teamJersey {
                svg
              }
            }
          }
          playerStat {
            value
            units
            period
          }
        }
        totalReceivingYards {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          result {
            type
          }
          teamNumberFireId
          player {
            numberfireId
            name
            lastName
            jerseyNumber
            imageUrl
            position
            injury {
              injured
              description
              publishedAt
              status
            }
            teamInfo {
              logo {
                svg
              }
              name
              shortName
              teamJersey {
                svg
              }
            }
          }
          playerStat {
            value
            units
            period
          }
        }
        totalPassingTDs {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          result {
            type
          }
          teamNumberFireId
          player {
            numberfireId
            name
            lastName
            jerseyNumber
            imageUrl
            position
            injury {
              injured
              description
              publishedAt
              status
            }
            teamInfo {
              logo {
                svg
              }
              name
              shortName
              teamJersey {
                svg
              }
            }
          }
          playerStat {
            value
            units
            period
          }
        }
      }
      numberfireId
      season
      week
      venueName
      venueType
      weather {
        condition
        humidity
        tempInF
        windDirection
        windSpeedInMph
      }
      startTime
      broadcastInfo {
        network
      }
      status
      homeTeam {
        name
        shortName
        abbreviation
        conference
        division
        primaryColor
        secondaryColor
        logoSVG
        numberfireId
        teamJerseySVG
        teamSportsbookUrl
        record {
          divisionRank
          conferenceRank
          divisionRecord {
            wins
            losses
            ties
            winPercentage
          }
          conferenceRecord {
            wins
            losses
            ties
            winPercentage
          }
          regularSeasonRecord {
            wins
            losses
            ties
            winPercentage
          }
          clinched
        }
      }
      awayTeam {
        name
        shortName
        abbreviation
        conference
        division
        primaryColor
        secondaryColor
        logoSVG
        numberfireId
        teamJerseySVG
        teamSportsbookUrl
        record {
          divisionRank
          conferenceRank
          divisionRecord {
            wins
            losses
            ties
            winPercentage
          }
          conferenceRecord {
            wins
            losses
            ties
            winPercentage
          }
          regularSeasonRecord {
            wins
            losses
            ties
            winPercentage
          }
          clinched
        }
      }
      odds {
        moneyline {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          result {
            type
          }
          teamNumberFireId
          playerStat {
            value
            units
            period
          }
        }
        spread {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          teamNumberFireId
        }
        totalPoints {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          teamNumberFireId
        }
        alternateTotalPoints {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          teamNumberFireId
        }
        awayTeamTotalPoints {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          teamNumberFireId
        }
        homeTeamTotalPoints {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          teamNumberFireId
        }
        totalPointsOddOrEven {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          teamNumberFireId
        }
      }
      historicalOdds {
        isLive
        timestamp
        homeSpread
        homeSpreadOdds
        awaySpread
        awaySpreadOdds
        homeMoneylineOdds
        awayMoneylineOdds
        ouTotalPoints
        overTotalPointsOdds
        underTotalPointsOdds
      }
      scoreboard {
        firstQuarter {
          home
          away
        }
        secondQuarter {
          home
          away
        }
        thirdQuarter {
          home
          away
        }
        fourthQuarter {
          home
          away
        }
        overtime {
          home
          away
        }
        finalScore {
          home
          away
        }
      }
      oddsResult {
        home {
          spread {
            line
            odds
            success
          }
          moneyline {
            odds
            success
          }
        }
        away {
          moneyline {
            odds
            success
          }
          spread {
            line
            odds
            success
          }
        }
        over {
          line
          odds
          success
        }
        under {
          line
          odds
          success
        }
      }
    }
  }
`);
